"use strict";

exports.__esModule = true;
exports.default = void 0;

var _uiSchema = _interopRequireDefault(require("../../roles/uiSchema"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  "ui:layout": "section",
  "ui:title": "Arbeid",
  "ui:label": false,
  "ui:preview": {
    "select": {
      "description": "description"
    },

    prepare({
      formData
    }) {
      return {
        description: formData && formData.title || "Uten tittel"
      };
    }

  },
  "ui:options": {
    "grid": true,
    "spacing": 2,
    "collapsible": true
  },
  "ui:fieldset": ["title", "description", "completedAt", "roles"],
  "title": {
    "ui:title": "Tittel",
    "ui:help": "Kort beskrivelse av arbeidet"
  },
  "description": {
    "ui:title": "Detaljer",
    "ui:widget": "textarea",
    "ui:help": "Evt. utfyllende beskrivelse av arbeidet"
  },
  "completedAt": {
    "ui:title": "Utført dato"
  },
  "roles": _uiSchema.default
};
exports.default = _default;
module.exports = exports.default;